<template lang="html">
  <Form v-if="form" :label-width="140" @submit.native.prevent="post(form)">
    <FormItem label="Nome">
      <Input v-model="form.name"/>
    </FormItem>
    <FormItem label="Logo">
      <input type="file" ref="file"/>
       
    </FormItem>
    <FormItem label="Partita IVA">
      <Input v-model="form.piva"/>
    </FormItem>
    <FormItem label="Codice Fiscale">
      <Input v-model="form.cf"/>
    </FormItem>
    <FormItem label="Telefono">
      <Input v-model="form.telephone"/>
    </FormItem>
    <FormItem label="Fax">
      <Input v-model="form.fax"/>
    </FormItem>
    <FormItem label="Email">
      <Input type="email" v-model="form.email"/>
    </FormItem>
    <FormItem label="Indirizzo">
      <Input v-model="form.addr_street"/>
    </FormItem>
    <FormItem label="Città">
      <Input v-model="form.addr_city"/>
    </FormItem>
    <FormItem label="Provincia">
      <Input v-model="form.provincia"/>
    </FormItem>
    <FormItem label="CAP">
      <Input v-model="form.addr_zip"/>
    </FormItem>
    <FormItem label="Legale Rappresentate">
      <Input v-model="form.legale_name"/>
    </FormItem>
    <FormItem label="Legale Rappresentate (email)">
      <Input v-model="form.legale_email"/>
    </FormItem>
    <FormItem v-for="r in roles" :label="r.label" :key="r.name">
      <div>
        <Select v-model="form['user_'+r.role]" filterable :disabled="false" clearable>
          <Option v-for="u in users" :key="u.id" :value="u.id">{{ u.name }} [{{ u.email }}]</Option>
        </Select>
        <Button icon="plus-round" @click="addUser(u => form['user_'+r.role] = u.id)"/>
      </div>
    </FormItem>
    <FormItem label="Indirizzo modulo registrazione soci">
      <i>tramite questo indirizzo sarà possibile far registrare i soci in totale autonomia, completare questo campo usando un nome indicativo composto solo di lettere o trattini -</i>
      <div>
        <Input v-model="form.slug">
          <span slot="prepend">{{`https://${location.host}/#/registrazione/`}}</span>
        </Input>
        <i v-if="form.slug">{{ `https://${location.host}/#/registrazione/${form.slug}` }}</i>
      </div>
    </FormItem>
    <FormItem label="Privacy policy">
      <wysiwyg v-model="form.privacy_policy" />
    </FormItem>
    <FormItem label="Modalità">
      <RadioGroup :value="1*form.has_comp" @input="form.has_comp = !!$event; if(!form.has_comp)form.perc_amm=100">
        <Radio size="large" :label="0">
          &nbsp;&nbsp;
          Cassa
        </Radio>
        <Radio size="large" :label="1">
          &nbsp;&nbsp;
          Cassa e competenza
        </Radio>
      </RadioGroup>
    </FormItem>
    <FormItem label="" style="margin-top: -1rem" v-if="form.has_comp">
      <div class="columns text-center" style="width: 70%; line-height: 2.2">
        <b>Percentuale di ammortamento:
          <input v-model="form.perc_amm" style="padding: 0 0; width: 2.5rem; text-align:center" type="number"/>%</b>
        <input class="slider-color" style="" type="range" min="0" max="100" step="1" v-model="form.perc_amm"/>
        <i style="">Trascina il pallino verde per cambiare la percentuale di ammortamento</i>
      </div>
    </FormItem>
    <FormItem>
      <Checkbox v-model="form.has_iva" type="checkbox" size="large">
        &nbsp;&nbsp;
        Abilita gestione IVA
      </Checkbox>
    </FormItem>
    <FormItem>
      <Checkbox v-model="form.has_partita_doppia" type="checkbox" size="large">
        &nbsp;&nbsp;
        Abilita movimenti in partita doppia
      </Checkbox>
    </FormItem>
    <!-- <FormItem>
      <Checkbox v-model="form.has_comp" type="checkbox" size="large">
        &nbsp;&nbsp;
        Abilita gestione per competenza
      </Checkbox>
    </FormItem> -->

    <div style="text-align: center">
      <Button type="error" @click="form=null;$parent.$parent.$parent.$parent.show_form=false">
        Annulla
      </Button>
      &nbsp;
      <Button :loading="saving" type="primary" @click="post(form)">
        Salva
      </Button>
    </div>
  </Form>
</template>

<script>
export default {
  props: [
    'form'
  ],

  data() {
    return {
      users: [],
      console,
      location,
      saving: false,
      roles: [
        {role: 'admin', label: 'Amministratore'},
        {role: 'president', label: 'Presidente'},
        {role: 'vice', label: 'Vicepresidente'},
      ]
    }
  },

  mounted () {
    this.refreshRoles()
    this.$http.get('users').then(res => {
      this.users = res.data
    })
  },

  methods: {
    post(data) {
      console.log(data)
      this.saving = true
      data.update_roles = 1
      this.$http.post('companies', data).then(res => {
        console.log(this.$parent.$parent.$parent.$parent)
        this.$parent.$parent.$parent.$parent.show_form=false
        this.$parent.$parent.$parent.$parent.refreshCompanies()
      }).finally(res => { this.saving = false
      this.form = null
       })
    },
    addUser (cb) {
      var user = {}
      user.name = prompt('Nome del nuovo utente')
      if (!user.name) return
      user.email = prompt('Indirizzo email del nuovo utente')
      if (!user.email) return
      user.is_admin = 0//prompt('Superadmin? (1 = Vero | 0 = Falso)')
      //if (!user.is_admin || (user.is_admin != 0 && user.is_admin != 1)) return window.alert("Campo Superadmin errato");
      /*console.log(this.$store.config.NAME=="Edesoft")
      console.log(this.$store.config.IS_LOCAL==null)
      if(this.$store.config.NAME=="Edesoft"&&this.$store.config.IS_LOCAL==null)
      {
        console.log("done123")
        user.status=1
      }
      */
      user.status=1
      this.$http.post('users', user).then(res => {
        this.users.push(res.data)
        cb(res.data)
      })

    },

    refreshRoles () {
      var f = this.form

      this.roles.forEach(r => { //console.log(f['user_'+r.role])
      f['user_'+r.role] = r.id
      console.log(f['user_'+r.role])
      })

      if(this.form['roles']!=undefined)
      {
          this.form['roles'].forEach(role => {
        
        f['user_'+role.role] = role.user.id
        console.log(f['user_'+role.role])
        
      });
      }
    }
  },
  watch: {
    form (f) {
      if (f) {
        this.refreshRoles()
      }
    }
  }
}
</script>

<style lang="css">
</style>
